namespace $.$$ {

	$mol_style_define( $shm_tests_benchmark_table, {

		width: '100%',
		minWidth: 0,

		Col_head: {
			color: $mol_theme.text,
			whiteSpace: 'normal',
		},

		Cell_text: {
			color: $mol_theme.text,
			whiteSpace: 'normal',
		},

	} )

}
